import { useFormContext } from '@calendly/form'
import { useRef, useState } from 'react'

export const useEditableLocationItem = ({ isConfirmed, fieldNamePrefix, fields, removeLocation }) => {
  const { setFieldValue } = useFormContext()
  const [isEditing, setIsEditing] = useState(!isConfirmed)
  const isNewRef = useRef(!isConfirmed)
  const snapshotRef = useRef(fields)

  const startEditing = () => {
    snapshotRef.current = fields
    setIsEditing(true)
  }

  const handleDone = () => {
    isNewRef.current = false
    setIsEditing(false)
  }

  const handleCancel = () => {
    if (isNewRef.current) {
      removeLocation()
      return
    }

    Object.entries(snapshotRef.current).forEach(([key, value]) => {
      setFieldValue(`${fieldNamePrefix}.${key}`, value)
    })
    setIsEditing(false)
  }

  return { isEditing, isNew: isNewRef.current, startEditing, handleDone, handleCancel }
}
